import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=2d2c6358&scoped=true&"
import script from "./Blogs.vue?vue&type=script&lang=js&"
export * from "./Blogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c6358",
  null
  
)

export default component.exports